const SCHEMA_FORM_MODAL_CONFIG = {
  maxWidth: 'md',
  fullWidth: true,
  validationMode: 'all',
};

export default SCHEMA_FORM_MODAL_CONFIG;
